// extracted by mini-css-extract-plugin
module.exports = {"header":"DashboardHeader_header__1lsPE","title":"DashboardHeader_title__IgZU-","switcher":"DashboardHeader_switcher__3UvHf"};